import React, { useState } from 'react';
import { Box, Icon, Text } from '@cubeyou-team/hx-react-components';
import { StyledDemographicsItem, StyledDraggableIcon } from './components';

const DemographicItem = ({
  item,
  type,
  onDemographicSelected,
  onItemDragToggle,
}: {
  item: any;
  type: string;
  onDemographicSelected?: (item: any, type: string) => void;
  onItemDragToggle?: (v: boolean) => void;
}) => {
  const [isDragging, SetIsDragging] = useState(false);

  const handleOnDemoClick = () => {
    !isDragging && onDemographicSelected(item, type);
  };

  return (
    <StyledDemographicsItem
      data-item-id={item.id}
      data-demo-class={type}
      isDragging={isDragging}
      draggable
      onDragStart={e => {
        SetIsDragging(true);
        onItemDragToggle(true);
        // @ts-ignore
        e.dataTransfer.setData('itemId', e.target.dataset.itemId);
        // @ts-ignore
        e.dataTransfer.setData('isDemographic', true);
        // @ts-ignore
        e.dataTransfer.setData('demoClass', `${e.target.dataset.demoClass}`);
        e.dataTransfer.setData('itemInfos', JSON.stringify(item));
      }}
      onDragEnd={() => {
        SetIsDragging(false);
        onItemDragToggle(false);
      }}
      onClick={handleOnDemoClick}
    >
      <StyledDraggableIcon>
        <Icon icon="drag" size="small" variant="dark_lighter" />
      </StyledDraggableIcon>

      <Box pL="large">
        <Text size="xbody" weight="bold">
          {item.label}
        </Text>
      </Box>
    </StyledDemographicsItem>
  );
};

export default DemographicItem;
